export * from "./normalMaterial.js";
//# sourceMappingURL=index.js.map